import React, { useState, useRef } from 'react';
import { 
  GiD4, 
  GiD10, 
  GiD12, 
  GiDiceEightFacesEight, 
  GiPerspectiveDiceSix, 
  GiDiceTwentyFacesTwenty 
} from 'react-icons/gi';
import { useLocation } from 'react-router-dom';
import { useChat } from '../context/ChatContext';
import diceSound from '../assets/sounds/dice-roll.mp3';
import './DiceRoller.css';

const DiceRoller = () => {
  const [d20Result, setD20Result] = useState(null);
  const [d12Result, setD12Result] = useState(null);
  const [d10Result, setD10Result] = useState(null);
  const [d8Result, setD8Result] = useState(null);
  const [d6Result, setD6Result] = useState(null);
  const [d4Result, setD4Result] = useState(null);
  
  const [isRollingD20, setIsRollingD20] = useState(false);
  const [isRollingD12, setIsRollingD12] = useState(false);
  const [isRollingD10, setIsRollingD10] = useState(false);
  const [isRollingD8, setIsRollingD8] = useState(false);
  const [isRollingD6, setIsRollingD6] = useState(false);
  const [isRollingD4, setIsRollingD4] = useState(false);
  
  const location = useLocation();
  const audioRef = useRef(new Audio(diceSound));
  const { addMessage } = useChat(); // Access the chat context

  const showDice = location.pathname.includes('story') || 
                   location.pathname.includes('travel') ||
                   location.pathname === '/table';

  const playDiceSound = () => {
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(console.error);
  };

  // Original dice roll functions
  const rollD20 = () => {
    setIsRollingD20(true);
    setD20Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 20) + 1;
      setD20Result(roll);
      setIsRollingD20(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d20.`);
    }, 500);
  };

  const rollD6 = () => {
    setIsRollingD6(true);
    setD6Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 6) + 1;
      setD6Result(roll);
      setIsRollingD6(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d6.`);
    }, 500);
  };

  const rollD4 = () => {
    setIsRollingD4(true);
    setD4Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 4) + 1;
      setD4Result(roll);
      setIsRollingD4(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d4.`);
    }, 500);
  };

  // New dice roll functions
  const rollD12 = () => {
    setIsRollingD12(true);
    setD12Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 12) + 1;
      setD12Result(roll);
      setIsRollingD12(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d12.`);
    }, 500);
  };

  const rollD10 = () => {
    setIsRollingD10(true);
    setD10Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 10) + 1;
      setD10Result(roll);
      setIsRollingD10(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d10.`);
    }, 500);
  };

  const rollD8 = () => {
    setIsRollingD8(true);
    setD8Result('...');
    playDiceSound();
    
    setTimeout(() => {
      const roll = Math.floor(Math.random() * 8) + 1;
      setD8Result(roll);
      setIsRollingD8(false);
      
      // Send the result to Chester
      addMessage('bot', `You rolled a ${roll} on a d8.`);
    }, 500);
  };

  if (!showDice) return null;

  return (
    <>
      <button 
        className={`dice-roller d4 ${isRollingD4 ? 'rolling' : ''}`} 
        onClick={rollD4}
        disabled={isRollingD4}
      >
        <GiD4 />
        <span>{d4Result || 'd4'}</span>
      </button>

      <button 
        className={`dice-roller d6 ${isRollingD6 ? 'rolling' : ''}`} 
        onClick={rollD6}
        disabled={isRollingD6}
      >
        <GiPerspectiveDiceSix />
        <span>{d6Result || 'd6'}</span>
      </button>

      <button 
        className={`dice-roller d8 ${isRollingD8 ? 'rolling' : ''}`} 
        onClick={rollD8}
        disabled={isRollingD8}
      >
        <GiDiceEightFacesEight />
        <span>{d8Result || 'd8'}</span>
      </button>

      <button 
        className={`dice-roller d10 ${isRollingD10 ? 'rolling' : ''}`} 
        onClick={rollD10}
        disabled={isRollingD10}
      >
        <GiD10 />
        <span>{d10Result || 'd10'}</span>
      </button>

      <button 
        className={`dice-roller d12 ${isRollingD12 ? 'rolling' : ''}`} 
        onClick={rollD12}
        disabled={isRollingD12}
      >
        <GiD12 />
        <span>{d12Result || 'd12'}</span>
      </button>

      <button 
        className={`dice-roller d20 ${isRollingD20 ? 'rolling' : ''}`} 
        onClick={rollD20}
        disabled={isRollingD20}
      >
        <GiDiceTwentyFacesTwenty />
        <span>{d20Result || 'd20'}</span>
      </button>
    </>
  );
};

export default DiceRoller;